import declare from "dojo/_base/declare";
import HomePageUtil from "./util";
import NewItemPaneForm from "./NewItemPaneForm";

const NewProofingPaneForm = declare(NewItemPaneForm, {
	allowedPaneIds: [
		"HomeAllProofs",
		"HomeMyProofs",
	],

	/**
	 * @override
	 * Return context types of views that are allowed for selection in this form
	 */
	getContextTypes(): string[] {
		return [];
	},
});

export = NewProofingPaneForm;